import styled from 'styled-components';
import EditPen from '../../../themes/svg/editPen';

export const FlexCol = styled.div`
display: flex;
flex-direction: column;
padding: 1rem 2rem;
`;

export const SummaryModalHeader1 = styled.div`
  margin-bottom: 10px;
  font-size: 1.4rem;
  font-weight: bold;
`;

export const FlexRow = styled.div`
display: flex;
flex-direction: row;
align-items: center;
`;

export const BoxedEditPen = styled(EditPen)`
background-color: #f8f8f8;
border-radius: 3px;
padding: 5px;
fill: black;
margin-left: 1.5em;
`;

export const SpecialInstructions = styled.textarea`
font-size: 1rem !important;
min-height: 168px;
`;

export const Option = styled.label`
display: flex;
flex-direction: column;
margin-bottom: 1em;
line-height: 1.5em;
`;

export const EditButton = styled.span`
cursor: pointer;
`;
